<template>
  <!-- The sysadmin's cost line under an AI answer (spec 2026-10-07-ki-nutzung-kosten §4). The server sends the
       cost fields to sysadmins only, so this renders nothing for everyone else. -->
  <p v-if="text" class="ki-kosten-zeile" data-test="ai-cost">{{ text }}</p>
</template>

<script>
import { aiCostText } from '@/editor-v2/utils/aiCost';

export default {
  name: 'KiKostenZeile',
  props: {
    // Any object with the flat fields kostenAufrufe, kostenTokens, kostenMikroUsd, kostenMikroEur, kostenModelle.
    kosten: { type: Object, default: null },
  },
  computed: {
    text() {
      return aiCostText(this.kosten);
    },
  },
};
</script>

<style lang="scss" scoped>
.ki-kosten-zeile { margin: 0; font-size: 12px; color: #6b7280; }
</style>
